// Music theory helpers shared by the staff renderer and audio engine.

export const NOTE_SEMITONES = { C: 0, D: 2, E: 4, F: 5, G: 7, A: 9, B: 11 };
export const STEP_INDEX = { C: 0, D: 1, E: 2, F: 3, G: 4, A: 5, B: 6 };
export const LETTERS = ["C", "D", "E", "F", "G", "A", "B"];

export function parsePitch(pitch) {
  const m = /^([A-G])(#|b)?(\d)$/.exec(pitch);
  if (!m) return null;
  return { letter: m[1], accidental: m[2] || null, octave: parseInt(m[3], 10) };
}

export function pitchToMidi(pitch) {
  const p = parsePitch(pitch);
  if (!p) return null;
  let semitone = NOTE_SEMITONES[p.letter];
  if (p.accidental === "#") semitone += 1;
  if (p.accidental === "b") semitone -= 1;
  return (p.octave + 1) * 12 + semitone;
}

export function pitchToFreq(pitch) {
  const midi = pitchToMidi(pitch);
  if (midi == null) return null;
  return 440 * Math.pow(2, (midi - 69) / 12);
}

// Diatonic index ignores accidentals (used for vertical staff position).
export function diatonicIndex(pitch) {
  const p = parsePitch(pitch);
  if (!p) return null;
  return p.octave * 7 + STEP_INDEX[p.letter];
}

export const SOLFEGE = ["Do", "Re", "Mi", "Fa", "Sol", "La", "Ti"];
